export default function TextField() {
  return {
    MuiTextField: {
      root: {
        '&$disabled': {
          styleOverrides: {
            color: 'red'
          }
        }
      },
      defaultProps: {
        disabled: false,
        size: 'small'
      },
      styleOverrides: {}
    }
  };
}
